import type { ApiFetchInit } from './fetch';
import { ApiError } from './fetch';
import { apiFetchWithTimeout } from './fetch-timeout';

export async function adminFetchJson<T>(path: string, init?: ApiFetchInit): Promise<T> {
  const res = await apiFetchWithTimeout(path, init);
  if (!res.ok) {
    throw new ApiError(`Admin request failed: ${path}`, res.status);
  }
  return (await res.json()) as T;
}

export async function adminFetchOk(path: string, init?: ApiFetchInit): Promise<Response> {
  const res = await apiFetchWithTimeout(path, init);
  if (!res.ok) {
    throw new ApiError(`Admin request failed: ${path}`, res.status);
  }
  return res;
}
